import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, Input, Output, TemplateRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GlobalEventsService } from '@coin/shared/core/util-helpers';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'coin-v2-dialog-frame',
  templateUrl: './v2-dialog-frame.component.html',
  styleUrls: ['./v2-dialog-frame.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class V2DialogFrameComponent {
  @Input({ required: true }) header: string | TemplateRef<unknown>;

  @Output() closeButtonClick = new EventEmitter<void>();

  private elementRef = inject(ElementRef);
  private globalEvents = inject(GlobalEventsService);

  protected get showCloseButton(): boolean {
    return this.closeButtonClick.observed;
  }

  protected get isCustomHeader(): boolean {
    return this.header instanceof TemplateRef;
  }

  constructor() {
    this.closeOnEscape();
  }

  private closeOnEscape(): void {
    this.globalEvents
      .listen('keydown')
      .pipe(
        filter(event => {
          if (
            event.key !== 'Escape' ||
            !this.showCloseButton ||
            event.defaultPrevented ||
            !(event.target instanceof Node)
          ) {
            return false;
          }
          const host = this.elementRef.nativeElement;
          return host.contains(event.target) || event.target.contains(host);
        }),
        takeUntilDestroyed()
      )
      .subscribe(event => {
        event.stopPropagation();
        event.preventDefault();
        this.closeButtonClick.emit();
      });
  }
}
